/* eslint-disable @typescript-eslint/no-explicit-any */
import 'process/browser.js';
import { Buffer } from "buffer";
(window as any).Buffer = Buffer;
